import React from "react";
import { CardContato } from "./CardContato";


export function ColunaKanban({
  titulo,
  status,
  contatos = [],
  onDropContato
}) {


  function handleDragOver(e){
    e.preventDefault();
  }


  function handleDrop(e){

    e.preventDefault();

    const contatoId = e.dataTransfer.getData("contatoId");

    if(onDropContato){

      onDropContato(
        contatoId,
        status
      );

    }

  }


  return (

    <div
      onDragOver={handleDragOver}
      onDrop={handleDrop}

      className="
        bg-background
        rounded-card
        p-4
        min-h-[450px]
      "
    >


      <div
        className="
          flex
          justify-between
          items-center
          mb-4
        "
      >

        <h3
          className="
            font-bold
            text-text-primary
          "
        >
          {titulo}
        </h3>


        <span
          className="
            text-caption
            text-text-secondary
          "
        >
          {contatos.length}
        </span>


      </div>



      <div className="space-y-3">


        {
          contatos.map((contato)=>(

            <CardContato

              key={contato.id}

              contato={contato}

            />

          ))
        }


      </div>


    </div>

  );

}